define ['./ssn.css'], () ->
  (RentappService, $state, $filter) ->
    restrict: "E"
    template: require("./ssn.jade")
    scope: {field: "=", mode: "@", index: "=", stage: "=", hijack: "="}
    link: (scope, element, attrs) ->
      scope.type = "password"
      if scope.mode == 'view' and scope.field.value.search(/XXX/)  != -1
        scope.show_explanation = true
      else
        scope.show_explanation = false

      if scope.field.required and scope.mode == 'edit'
        scope.field_label = "#{scope.field.label}<span>&nbsp;*</span>"
      else
        scope.field_label = scope.field.label
      
      scope.toggleShow = () ->
        if scope.type == 'password'
          scope.type = 'text'
        else
          scope.type = 'password'



// WEBPACK FOOTER //
// ./directives/freeforms/ssn/ssn.coffee